import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";

const services = [
  {
    id: "planejamento", icon: "✈️", title: "Planejamento Personalizado", subtitle: "Roteiros sob medida",
    desc: "Criamos roteiros únicos e exclusivos baseados nos seus sonhos, preferências e orçamento. Do destino ao hotel, passando por passeios e gastronomia, cuidamos de cada detalhe.",
    features: ["Roteiro 100% personalizado", "Suporte 24/7 durante a viagem", "Consultoria especializada", "Flexibilidade total de datas"],
    image: "https://images.pexels.com/photos/3278215/pexels-photo-3278215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    color: "from-slate-50 to-blue-50",
  },
  {
    id: "pacotes", icon: "🏖️", title: "Pacotes de Férias", subtitle: "Tudo incluído",
    desc: "Pacotes completos que incluem passagem aérea, hospedagem, transfers e passeios selecionados. Experiência completa com comodidade e praticidade para toda a família.",
    features: ["Passagem aérea inclusa", "Hotel com café da manhã", "Transfer aeroporto/hotel", "Seguro viagem opcional"],
    image: "https://images.pexels.com/photos/2724079/pexels-photo-2724079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    color: "from-teal-50 to-green-50",
  },
  {
    id: "luxo", icon: "💎", title: "Viagens de Luxo", subtitle: "Premium & exclusivo",
    desc: "Experiências de alto padrão com hotéis 5 estrelas, suítes exclusivas, jantares gourmet, passeios privados e serviço concierge personalizado 24 horas.",
    features: ["Hotéis 5 estrelas", "Concierge exclusivo", "Transfers em veículos premium", "Experiências gastronômicas"],
    image: "https://images.unsplash.com/photo-1759038085950-1234ca8f5fed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB0cmF2ZWwlMjBjb25jaWVyZ2UlMjBkZXNrJTIwcGxhbm5pbmd8ZW58MHx8fHwxNzc0NDQzODgxfDA&ixlib=rb-4.1.0&q=85",
    color: "from-amber-50 to-yellow-50",
  },
  {
    id: "grupo", icon: "👥", title: "Viagens em Grupo", subtitle: "Para famílias e empresas",
    desc: "Especialistas em viagens corporativas, eventos internacionais, turismo de incentivo e viagens em grupo para famílias e amigos. Condições especiais para grupos.",
    features: ["Condições especiais para grupos", "Eventos corporativos", "Turismo de incentivo", "Logística completa"],
    image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    color: "from-purple-50 to-pink-50",
  },
  {
    id: "consultoria", icon: "🗺️", title: "Consultoria de Viagem", subtitle: "Orientação especializada",
    desc: "Para quem prefere planejar com autonomia, oferecemos consultoria especializada: orientações sobre vistos, vacinações, câmbio, seguro viagem e muito mais.",
    features: ["Orientação sobre vistos", "Informações de vacinação", "Dicas de câmbio", "Seguro viagem"],
    image: "https://images.pexels.com/photos/3171837/pexels-photo-3171837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    color: "from-orange-50 to-red-50",
  },
];

const Services = () => (
  <div data-testid="services-page" className="pt-16 md:pt-20">
    <section className="page-hero flex items-center justify-center min-h-[350px] relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: "url(https://images.unsplash.com/photo-1759038085950-1234ca8f5fed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB0cmF2ZWwlMjBjb25jaWVyZ2UlMjBkZXNrJTIwcGxhbm5pbmd8ZW58MHx8fHwxNzc0NDQzODgxfDA&ixlib=rb-4.1.0&q=85)" }} />
      <div className="relative z-10 text-center text-white px-4">
        <p className="text-[#89A6A3] font-semibold tracking-widest text-sm uppercase mb-3">O que fazemos</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold">Nossos Serviços</h1>
        <p className="mt-4 text-white/80 text-lg max-w-xl mx-auto">Soluções completas para tornar cada viagem uma experiência extraordinária.</p>
      </div>
    </section>

    <section data-testid="services-list-section" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-20">
          {services.map((service, i) => (
            <div key={service.id} data-testid={`service-detail-${service.id}`}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}>
              <div className={i % 2 !== 0 ? 'lg:order-2' : ''}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img src={service.image} alt={service.title} className="w-full h-72 md:h-80 object-cover" loading="lazy" />
                </div>
              </div>
              <div className={`${i % 2 !== 0 ? 'lg:order-1' : ''} bg-gradient-to-br ${service.color} p-8 rounded-2xl`}>
                <span className="text-4xl">{service.icon}</span>
                <p className="text-[#89A6A3] font-semibold text-sm tracking-widest uppercase mt-4 mb-1">{service.subtitle}</p>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2E4E72] mb-4">{service.title}</h2>
                <p className="text-slate-600 leading-relaxed mb-6">{service.desc}</p>
                <ul className="space-y-2 mb-8">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-slate-700">
                      <CheckCircle size={18} className="text-[#89A6A3] flex-shrink-0" />
                      <span className="text-sm">{f}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/contato" data-testid={`service-cta-${service.id}`}
                  className="inline-flex items-center gap-2 bg-[#2E4E72] text-white font-bold px-7 py-3 rounded-full hover:bg-[#3A6080] transition-all duration-300">
                  Solicitar Informações <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-[#2E4E72] py-20 text-center">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="font-heading text-4xl font-bold text-white mb-4">Não encontrou o que procura?</h2>
        <p className="text-white/75 text-lg mb-8">Entre em contato e criamos um serviço personalizado especialmente para você.</p>
        <Link to="/contato" data-testid="services-bottom-cta"
          className="bg-[#89A6A3] text-[#2E4E72] font-bold px-10 py-4 rounded-full text-lg hover:bg-[#6B8C89] hover:text-white hover:scale-105 transition-all duration-300 inline-block">
          Fale Conosco
        </Link>
      </div>
    </section>
  </div>
);

export default Services;
